import { PlusOutlined } from '@ant-design/icons'
import { Button, Col } from 'antd'
import { useState } from 'react'
import OlympiadNameList from './ListOlympiadName';
import ManageOlympiadName from './ManageOlympiadName';

function StemiOlympiadNameView() {

  const selectWidth = "50%";
  const initWidth = 900;

  const [visible, setVisible] = useState(false);
  const [hasUpdated, setHasUpdated] = useState(true);
  const [modalType, setModalType] = useState("Add");
  const [modalWidth, setModalWidth] = useState(initWidth);

  // const [mainTitle, setMainTitle] = useState(defaultTitle);

  const showModal = (record, type) => {

    console.log("showModal", record, type);
    setVisible(record);
    setModalType(type)
  };

  return (
    <>
      <div className="content">
        <Col xs={24}>
          <h1 className="center-align">STEMI Olympiad Name Management</h1>
        </Col>
        <Button
          className="add-button"
          key="add-button-1"
          type="primary"
          onClick={() => showModal({}, "Add")}
          icon={<PlusOutlined />}
        >
          {""} Add New Name
        </Button>

        <OlympiadNameList
          key={"olympiad name-list"}
          hasUpdated={hasUpdated}
          setHasUpdated={setHasUpdated}
          showModal={showModal}
        />
          <ManageOlympiadName
            key={"Edit_Olympiad_Name"}
            record={visible}
            showModal={showModal}
            setHasUpdated={setHasUpdated}
            hasUpdated={hasUpdated}
            initWidth={initWidth}
            modalWidth={modalWidth}
            setModalWidth={setModalWidth}
            modalType={modalType}
          />
      </div>
    </>
  )
}

export default StemiOlympiadNameView